import React, { Fragment } from 'react';

export default function Strip ({children, length}) {    

    let modifiedString = children || [];
    if(children?.length > length) modifiedString = children?.substring(0, length-5) + `..`

    return (  
        <Fragment> {modifiedString} </Fragment>       
    )
}